import { CompanyDisplay } from "./company.filter";
import { DebugLog } from "@me8eon/debug";
import { FiltersPlugin } from "@me8eon/filters/src/filters.plugin";

export const companyfilterPluginName = "company";
export type CompanyString = "local" | "compassWide"
export const companyStrings: CompanyString[] = ["local", "compassWide"];

export type CompanyFilters = {
    [companyfilterPluginName]: CompanyString | undefined
}

export const companyFilterPlugin: FiltersPlugin<CompanyFilters, "company"> = {
    plugin: "filter",
    type: companyfilterPluginName,
    DefaultDisplay: CompanyDisplay,
    changeCausesSubmit: true,
    deleteWhenClean: true,
    fromUrl: (debug: DebugLog, urlData, def) => {
        const company = urlData.url.searchParams.get(companyfilterPluginName) || def;
        if (!companyStrings.includes(company as CompanyString)) {
            debug("companyFilter fromUrl", "company=", company, `and it is not in ${companyStrings} so defaulting to`, def);
            return def;
        }
        debug("companyFilter fromUrl", "company=", company);
        return company as CompanyString || def;
    },
    addToUrl: (debug, sp, company) => {
        debug("companyFilter addToUrl", "company=", company);
        if (company && companyStrings.includes(company as CompanyString))
            sp.set(companyfilterPluginName, company);
        else
            sp.delete(companyfilterPluginName);
    },
};